import { DispensationStrategy } from "elephant-web/gql";
import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_DISPENSATION_COLLECTION_NAME = "dispensation";

export const useRxCollectionDispensation =
  (): RxCollection<Dispensation> | null =>
    useRxCollection<Dispensation>(RXDB_DISPENSATION_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<Dispensation>>;
export type DispensationQueryConstructor = UseRxData["1"];

export const useRxDataDispensation = (
  queryConstructor: UseRxData["1"],
  options?: UseRxData["2"],
) =>
  useRxData<Dispensation>(
    RXDB_DISPENSATION_COLLECTION_NAME,
    queryConstructor,
    options,
  );

const DISPENSATION_SCHEMA_LITERAL = {
  title: "dispensation schema",
  version: 2,
  description: "Represents a dispensation",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    dispensationStrategy: {
      type: "string",
      enum: Object.values(DispensationStrategy),
    },
    dispensedByUserId: {
      type: "string",
      maxLength: 100,
    },
    facilityId: {
      type: "string",
      maxLength: 100,
    },
    locationId: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    prescriptionId: {
      type: "string",
      maxLength: 100,
    },
    quantity: {
      type: ["integer", "null"],
      minimum: 0,
    },
    skuId: {
      type: ["string", "null"],
    },
  },
  required: [
    "id",
    "dispensationStrategy",
    "dispensedByUserId",
    "facilityId",
    "locationId",
    "meta",
    "prescriptionId",
    "quantity",
    "skuId",
  ],
  indexes: ["prescriptionId"],
  /*
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   */
} as const satisfies RxJsonSchema<any>;
const schemaTyped = toTypedRxJsonSchema(DISPENSATION_SCHEMA_LITERAL);
export type Dispensation = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const DISPENSATION_SCHEMA: RxJsonSchema<Dispensation> =
  DISPENSATION_SCHEMA_LITERAL;
